import { TileCoord } from './ortho-tile-typings';

/**
 * A minimal data-only quadtree helper:
 * roots are the lowest zoom mosaic tiles (one or several) from Levels[].
 */
export class TileQuadtree {
  readonly roots: TileCoord[];
  readonly minZoom: number;
  readonly maxZoom: number;

  constructor(params: { roots: TileCoord[]; minZoom: number; maxZoom: number }) {
    this.roots = params.roots;
    this.minZoom = params.minZoom;
    this.maxZoom = params.maxZoom;
  }

  childrenOf(coord: TileCoord): TileCoord[] {
    const z = coord.z + 1;
    const x2 = coord.x * 2;
    const y2 = coord.y * 2;
    return [
      { z, x: x2, y: y2 },
      { z, x: x2 + 1, y: y2 },
      { z, x: x2, y: y2 + 1 },
      { z, x: x2 + 1, y: y2 + 1 },
    ];
  }

  parentOf(coord: TileCoord): TileCoord | null {
    if (coord.z <= this.minZoom) {
      return null;
    }
    return { z: coord.z - 1, x: Math.floor(coord.x / 2), y: Math.floor(coord.y / 2) };
  }
}
